import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';

export const DEFAULT_VENDOR = 'Joy';

const OPTIMIZATION = 'aggressive';

export const saveTheDatePhotoECards: MarketingData = [
  {
    title: 'Ampersand Top',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/ampersand top.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Ampersand Top',
      themeId: 'ampersand_top',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Arch 1',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/arch 1.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Arch 1',
      themeId: 'arch_i',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Arch 2',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/arch 2.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Arch 2',
      themeId: 'arch_ii',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Big Names',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/big names.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Big Names',
      themeId: 'big_names',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Gilded Calligraphy',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/gilded calligraphy.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Gilded Calligraphy',
      themeId: 'gilded_calligraphy',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Gold Border Cursive',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/gold border cursive.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Gold Border Cursive',
      themeId: 'gold_border_cursive',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Gold Wreath',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/gold wreath.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Gold Wreath',
      themeId: 'gold_wreath',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Modular Texture',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/modular texture.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Modular Texture',
      themeId: 'modular_texture',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Side Cursive',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/side cursive.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Side Cursive',
      themeId: 'side_cursive',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Simple Retro Dark',
    imageUrl: cloudAssetUrl('save-the-date-gallery/ecard-thumbnails/1x/simple retro dark.jpg', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Simple Retro Dark',
      themeId: 'simple_retro_dark',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Simplicity',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-18.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Simplicity',
      themeId: 'simplicity',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Art Deco Navy',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-11.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Art Deco Navy',
      themeId: 'art_deco_navy',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Art Deco White',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-12.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Art Deco White',
      themeId: 'art_deco_white',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Gold Swash',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-14.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Gold Swash',
      themeId: 'gold_swash',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Picture Perfect',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-16.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Picture Perfect',
      themeId: 'picture_perfect',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Brushed Edge',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-13.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Brushed Edge',
      themeId: 'brushed_edge',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Script Dark',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-17.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Script Dark',
      themeId: 'script_dark',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
  {
    title: 'Ink & Gold',
    imageUrl: cloudAssetUrl('save-the-date-gallery/photo-ecards/card-15.png', { optimization: OPTIMIZATION }),
    theme: {
      name: 'Ink & Gold',
      themeId: 'ink_and_gold',
      marketingData: [],
    },
    isPhotoECards: true,
    productType: 'Save the Date',
    variationType: 'savethedate',
    tags: ['Photo'],
    colors: [],
    font: '',
    printUrl: '',
    vendor: '',
    variantColor: '',
    variantName: '',
    variantThemeId: '',
  },
];
